import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("linden_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const reportApiError = (scope) => (err) => {
  if (err?.response?.status !== 401) console.warn(`[${scope}] request failed`, err?.response?.status || err?.message);
};

if (typeof window !== "undefined") {
  window.addEventListener("unhandledrejection", (event) => {
    if (event.reason?.isAxiosError) {
      event.preventDefault();
      console.warn("[api] unhandled request failure", event.reason?.config?.url, event.reason?.response?.status);
    }
  });
}

export function apiErr(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
